import { Images } from '@/assets/imgs';
import { BtnRed } from '@/components/Buttons';
import { ObserverContainer } from '@/components/ObserverContainer';
import { WrapWordsAndLetters } from '@/components/WrapWordsAndLetters';
import clsx from 'clsx';
import Image from 'next/image';
import { useEffect, useState } from 'react';

export const Introduction = () => {
  const [isScrolled, setIsScrolled] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(true);
    }, 600);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 200) {
        setIsScrolled('scrolled-more');
      } else if (window.scrollY > 50) {
        setIsScrolled('scrolled');
      } else {
        setIsScrolled('not-scrolled');
      }
    });
  }, []);

  return (
    <div className="prometheus-introduction">
      <ObserverContainer
        className={clsx(isScrolled, isLoaded && 'loaded', 'robot lg section')}
      >
        <Image
          className="background"
          src={Images.prometheusNFT.hero}
          alt="hero"
          width={2112}
          height={1440}
        />
      </ObserverContainer>
      <div className="introduction-content flex column center">
        <ObserverContainer className="container">
          <div className="introduction-main">
            <span className="lexend-text-sm">
              The Prometheus NFT Collection
            </span>

            <h1 className="integralfc-h1">
              <WrapWordsAndLetters sentence="ADVANCING THE GAMING FRONTIER" />
            </h1>

            <p className="description">
              A collection of 1,111 torchbearers leading the gaming revolution
              and enjoying the most elit benefits within the XBorg ecosystem
            </p>

            <div className="flex actions">
              <BtnRed
                label="View OpenSea"
                href="https://opensea.io/collection/xborg-prometheus"
                className="lexend-body-sxl"
              />
            </div>
          </div>
        </ObserverContainer>
      </div>
    </div>
  );
};
